export enum TimeSpanEnum {
  TWO_WEEKS = 'two_weeks',
  ONE_MONTH = 'one_month',
  THREE_MONTHS = 'three_months',
}
